import Main from "../../components/signUp/main";

const SignUp = () => {
  return (
    <>
      <Main />
    </>
  );
};
export default SignUp;
